import { Component, EventEmitter, Input, Output, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Subject } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { Sgkb986aResCtrSearchresultDto, Sgkb986aResDescriptionDto } from 'sg-api';

interface NewSgkb986aResCtrSearchresultDto extends Sgkb986aResCtrSearchresultDto {
  pipe?: string;
  unitHeat?: string;
}

@Component({
  selector: 'app-sgkb713d-search-result',
  templateUrl: './sgkb713d-search-result.component.html',
  styleUrl: './sgkb713d-search-result.component.scss'
})
export class Sgkb713dSearchResultComponent implements OnInit, OnDestroy {

  /** 遷移元ステータス */
  @Input() mode : string;
  /** 契約検索APIレスポンス */
  @Input() ctrSearchresultList : Array<Sgkb986aResCtrSearchresultDto>;

  /** データ選択イベント */
  @Output() onSelectedEvent = new EventEmitter<any[]>();

  @ViewChild('sort1',{static: true}) sort: MatSort;

  private onDestroy$ = new Subject();

  /** チェックボックス */
  selectionClaimCharge = new SelectionModel<string>(true, []);

  /** 検索結果表示リスト */
  displayedColumnsCol: string[] = [
    'select',
    'firstSrvctrNo',
    'shiyouBashoJusho',
    'visitName',
    'enerugiShubetsu',
    'gyoshuLargebunruiAname',
    'prdGoodsRyaku',
    'combinedcontractDivCodeaname',
    'ctrstrDate',
    'ctrendDate',
    'usingVisitKnjnm',
    'extLinkId',
    'extCnnctNo',
  ];

  dataSource = new MatTableDataSource<NewSgkb986aResCtrSearchresultDto>();

  /**
   * コンストラクタ
   * @memberof Sgkb713dSearchResultComponent
   */
  constructor(
    public _dialogRef: MatDialogRef<Sgkb713dSearchResultComponent>,
  ) { }

  /**
   * 初期表示処理
   * @memberof Sgkb713dSearchResultComponent
   */
  ngOnInit(): void {
    // レスポンスの需給契約情報リストを設定
    this.dataSource.data = this.ctrSearchresultList;

    // 検索条件コンポーネントからのレスポンス個数分、処理を繰り返す
    for (let i=0; i < this.ctrSearchresultList.length; i++) {
      // 熱量のデータがある場合、熱量末尾に「MJ」を付与
      if (this.ctrSearchresultList[i].description.heatAname
          && this.ctrSearchresultList[i].description.heatAname != '') {
        this.dataSource.data[i].unitHeat = 'MJ';

        // エネルギー種別のデータがある場合、熱量先頭に「／」を付与
        if (this.ctrSearchresultList[i].description.energyClsfyCodeaname
            && this.ctrSearchresultList[i].description.energyClsfyCodeaname != '') {
          this.dataSource.data[i].pipe = '／';
        }
      }

      // 総合契約区分コード名称のデータがある場合
      if (this.ctrSearchresultList[i].description.combinedcontractDivCodeaname
          && this.ctrSearchresultList[i].description.combinedcontractDivCodeaname != '') {
        this.dataSource.data[i].description.combinedcontractDivCodeaname = '総合';
      } else {
        this.dataSource.data[i].description.combinedcontractDivCodeaname = '';
      }
    }
  }

  /**
   * 購読を停止する処理
   * @memberof Sgkb713dSearchResultComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * ソート処理
   * @memberof Sgkb713dSearchResultComponent
   */
  ngAfterViewInit() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'firstSrvctrNo':
          return item.description?.firstSrvctrNo ?? '';
        case 'shiyouBashoJusho':
          const description = item.empposInfo?.description ?? '';
          const mptAname = item.empposInfo?.mptAname ?? '';
          const townAreaName = item.empposInfo?.townAreaName ?? '';
          const ooazaName = item.empposInfo?.ooazaName ?? '';
          const bantiGoubunptgouAname = item.empposInfo?.bantiGoubunptgouAname ?? '';
          const supadrKanjiAname1 = item.empposInfo?.supadrKanjiAname1 ?? '';
          const yagouAname = item.empposInfo?.yagouAname ?? '';
          return description + mptAname + townAreaName + ooazaName
            + bantiGoubunptgouAname + supadrKanjiAname1 + yagouAname;
        case 'visitName':
          return item.ctrperInfo?.visitName ?? '';
        case 'enerugiShubetsu':
          const energyClsfyCodeaname = item.description?.energyClsfyCodeaname ?? '';
          const heatAname = item.description?.heatAname ?? '';
          return energyClsfyCodeaname + heatAname;
        case 'gyoshuLargebunruiAname':
          return item.description?.gyoshuLargebunruiAname ?? '';
        case 'prdGoodsRyaku':
          return item.description?.prdGoodsRyaku ?? '';
        case 'combinedcontractDivCodeaname':
          return item.description?.combinedcontractDivCodeaname ?? '';
        case 'ctrstrDate':
          return item.description?.ctrstrDate ?? '';
        case 'ctrendDate':
          return item.description?.ctrendDate ?? '';
        case 'usingVisitKnjnm':
          return item.userInfo?.usingVisitKnjnm ?? '';
        case 'extLinkId':
          return item.ctrperInfo?.extLinkId ?? '';
        case 'extCnnctNo':
          return item.empposInfo?.extCnnctNo ?? '';
        default:
          return '';
      }
    };
    this.dataSource.sort = this.sort;
  }

  /**
   * 閉じる押下処理
   * @memberof Sgkb713dSearchResultComponent
   */
  onClickCancel(): void {
    this._dialogRef.close();
  }

  /**
   * OK押下処理
   * @memberof Sgkb713dSearchResultComponent
   */
  onClickOk(selection: any): void {
    // 契約検索・一覧照会レスポンスの契約情報
    let sgkb986aResCtrSearchresultDtoList: Array<Sgkb986aResCtrSearchresultDto> = [];

    // 検索結果が選択されている場合、該当レコードを契約情報Dtoに設定
    if (selection.selected && selection.selected != '') {
      selection.selected.forEach(data => {
        let sgkb986aResDescriptionDto: Sgkb986aResCtrSearchresultDto = data;
        sgkb986aResCtrSearchresultDtoList.push(sgkb986aResDescriptionDto);
      });
    }

    this._dialogRef.close(sgkb986aResCtrSearchresultDtoList); 
  }

  /**
   * チェックボックス押下時の処理
   * @memberof Sgkb713dSearchResultComponent
   */
  onChangeSelection(event: any, selection: any): void {
    if (event) {
      this.onSelectedEvent.emit(
        selection.selected.sort((a, b) => {
          if (a.id < b.id) return -1;
          if (a.id > b.id) return 1;
        })
      );
    }
  }

  /**
   * すべて選択／選択解除の切り替え処理
   * @memberof Sgkb713dSearchResultComponent
   */
  masterToggle(selection: any, dataSource: any) {
    this.isAllSelected(selection, dataSource) ?
      selection.clear() :
      dataSource.data.forEach(row => selection.select(row));
  }
  /**
   * 全選択状態かの判定処理
   * @memberof Sgkb713dSearchResultComponent
   */
  isAllSelected(selection: any, dataSource: any) {
    const numSelected = selection.selected.length;
    const numRows = dataSource.data.length;
    return numSelected === numRows;
  }
  /**
   * 選択行のチェックボックスラベル処理
   * @memberof Sgkb713dSearchResultComponent
   */
  checkboxLabel(selection: any, dataSource: any, row?: any): string {
    if (!row) {
      return `${this.isAllSelected(selection, dataSource) ? 'select' : 'deselect'} all`;
    }
    return `${selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  /**
   * 検索結果変更処理
   * @memberof Sgkb713dSearchResultComponent
   */
  initLogic(ctrSearchresultList) {
    this.ctrSearchresultList = ctrSearchresultList;
    this.ngOnInit();
  }
}
